import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link, Box } from '@material-ui/core';
import { useBenefitsFooterStyles } from './styles';
import { termsRPGOBank, legalRPGOBank } from '../../../../../config/paths';

const BenefitsFooter = ({ ...props }) => {
  const { mobile } = props;
  const classes = useBenefitsFooterStyles();
  return (
    <Box className={mobile ? classes.boxMobile : classes.boxDesktop}>
      <div>
        <Link className={classes.linkText} href={termsRPGOBank} target="_blank">
          Leer términos y condiciones
        </Link>
        <Typography className={classes.lowerText}>
          *Desde el 01 de septiembre de 2019
        </Typography>
      </div>
      <div className={!mobile ? classes.textToRight : ''}>
        <Link className={classes.linkText} href={legalRPGOBank} target="_blank">
          Bases promocionales
        </Link>
        <Typography className={classes.lowerText}>
          *Desde el 01 de septiembre de 2019
        </Typography>
      </div>
    </Box>
  );
};

BenefitsFooter.propTypes = {
  mobile: PropTypes.bool,
};

export default BenefitsFooter;
